/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Nav_Templates_DescInputs */

const en_mk_nav_templates_desc = /** @type {(inputs: Mk_Nav_Templates_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Starting points for your business and projects.`)
};

const id_mk_nav_templates_desc = /** @type {(inputs: Mk_Nav_Templates_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Titik awal untuk usaha dan proyekmu.`)
};

/**
* | output |
* | --- |
* | "Starting points for your business and projects." |
*
* @param {Mk_Nav_Templates_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_nav_templates_desc = /** @type {((inputs?: Mk_Nav_Templates_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Nav_Templates_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_nav_templates_desc(inputs)
	return en_mk_nav_templates_desc(inputs)
});